import * as React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {ThemeProvider as MuiThemeProvider, CssBaseline} from '@material-ui/core';
import {ThemeProvider} from '@emotion/react';

import {MessageProvider} from 'context/message-context';
import {FetchProvider} from 'context/fetch-context';
import {HomeProvider} from 'context/home-context';
import {DeskBookingProvider} from 'context/deskbooking/deskbooking-context';

import Message from 'components/Message';
import theme from 'theme/AppTheme';

function AppProviders({children}) {
  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FetchProvider>
          <MessageProvider>
            <Message />
            <HomeProvider>
              <DeskBookingProvider>
                <Router>{children}</Router>
              </DeskBookingProvider>
            </HomeProvider>
          </MessageProvider>
        </FetchProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  );
}

export {AppProviders};
